import {ProductHandler} from '../ts-lib/product/product-handler';

document.addEventListener('DOMContentLoaded', function () {
    new ProductHandler()
});